import React from 'react';
import styles from './EmptyVeille.module.css';

const EmptyVeille: React.FC = () => (
  <div className={styles.container}>
    <span className={styles.text}>Touchez l&apos;écran pour commencer</span>
  </div>
);

export default EmptyVeille;
